import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MessagingService {

  currentMessage = new BehaviorSubject(null);

  constructor(
    private angularFireDB: AngularFireDatabase,
    private angularFireMessaging: AngularFireMessaging) {
    this.angularFireMessaging.messages.subscribe(
      (message) => {
      }
    );
  }

  /**
   * update token in firebase database
   *
   * @param keyTab userId as a table of deviceId
   * @param token token as a value
   */
  updateToken(keyTab, token) {

    for (const key of keyTab) {
      // See if the token is already stored in firebase
      this.angularFireDB.database.ref('/' + key + '/token').orderByValue().equalTo(token)
        .once('value').then(snapShot => {
          if (snapShot.exists()) {
            // Do nothing
          } else {
            // store it in firebase
            this.angularFireDB.database.ref('/' + key + '/token').push().set(token);
          }
        });
    }
    // Add token to cookies
    this.setCookie('token', token, 30);


  }

  /**
   * request permission for notification from firebase cloud messaging
   *
   * @param keyTab deviceId array
   */
  requestPermission(keyTab) {
    // console.log("request permission is on!")
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        // console.log("Your token is : "+token);
        this.updateToken(keyTab, token);
      },
      (err) => {
        console.error('Unable to get permission to notify. ', err);
      }
    );
  }

  /**
   * hook method when new notification received in foreground
   */
  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (payload) => {
        console.log('New message received. ', payload);
        this.currentMessage.next(payload);
      });


  }


  /** ===================================================
     * Cookies functions, because ngx-cookies won't work
     * ====================================================== */
  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  getCookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  checkCookie(cname): boolean {
    const cValue = this.getCookie(cname);
    if (cValue && cValue.length !== 0) {
      return true;
    } else {
      return false;
    }
  }
  /** ===========================
   * END cookies
   ============================== */
}
